const branchNameSearch = (p: string) => /CRM-\d*|release/.test(p);

export const getBaseName = () => {
  const path = window.location.pathname.split('/');
  const branchName = path.find(branchNameSearch);
  return branchName ? `/${branchName}/` : '/';
};
